import { FormHelperText } from '@mui/material'
import moment from 'moment'

export const isRequired = val => {
  if (val === null || val === undefined) {
    return false
  }

  if (typeof val === 'object') {
    if (val.hasOwnProperty('name')) {
      return val.name !== null && val.name !== undefined && val.name.toString().trim() !== ''
    }

    return Object.values(val).some(value => {
      return value !== null && value !== undefined && value.toString().trim() !== ''
    })
  }

  if (typeof val === 'number') {
    return val !== 0
  }

  return val.toString().trim() !== ''
}

const isValidLength = value => {
  if (!value) return false

  if (value.length < 6 || value.length > 12) {
    return false
  }

  if (!/^[a-zA-Z0-9]+$/.test(value)) {
    return false
  }

  return true
}

const isValidExactLength = value => {
  if (!value) return false

  if (value.length !== 12) {
    return false
  }

  if (!/^[a-zA-Z0-9]+$/.test(value)) {
    return false
  }

  return true
}

export const isDate = val => {
  if (val === null || val === undefined) {
    return false
  }
  if (typeof val === 'string') {
    return moment(val, ['DD.MM.YYYY', moment.ISO_8601], true).isValid()
  }

  const date = new Date(val)
  return !Number.isNaN(date.getTime())
}

export const clientDataFields = [
  // { name: 'lastName', error: 'Фамилия', validate: isRequired },
  // { name: 'firstName', error: 'Имя', validate: isRequired },
  { name: 'sexName', error: 'Пол', validate: isRequired },
  { name: 'resident', error: 'Резидент', validate: isRequired },
  { name: 'citizenship', error: 'Гражданство', validate: isRequired },
  { name: 'birthDate', error: 'Дата рождения', validate: isDate },
  { name: 'birthPlace', error: 'Место рождения', validate: isRequired },
  { name: 'documentType', error: 'Тип документа', validate: isRequired },
  { name: 'documentNumber', error: 'Номер документа', validate: isValidLength },
  { name: 'iin', error: 'ИИН', validate: isValidExactLength },
  { name: 'documentIssuer', error: 'Орган выдачи', validate: isRequired },
  { name: 'documentIssueDate', error: 'Дата выдачи', validate: isDate },
  { name: 'documentExpiryDate', error: 'Срок действия документа', validate: isDate },
  { name: 'education', error: 'Образование', validate: isRequired },
  { name: 'maritalStatus', error: 'Семейное положение', validate: isRequired },
  { name: 'organizationName', error: 'Название организации', validate: isRequired },
  // { name: 'employmentDuration', error: 'Стаж работы в организации', validate: isRequired },
  // { name: 'totalExperience', error: 'Общий стаж работы', validate: isRequired },
  { name: 'monthlyIncome', error: 'Общий месячный доход', validate: isRequired },
  { name: 'houseNumber', error: 'Дом', validate: isRequired },
  { name: 'street', error: 'Улица', validate: isRequired },
  { name: 'district', error: 'Район', validate: isRequired },
  { name: 'region', error: 'Область', validate: isRequired },
  { name: 'mobilePhone1', error: 'Мобильный телефон 1', validate: isRequired }
]

export const legalGuaranteeFields = [
  { name: 'organizationName', error: 'Наименование организации', validate: isRequired },
  { name: 'initialRegistrationDate', error: 'Дата первичной регистрации', validate: isRequired },
  { name: 'lastRegistrationDate', error: 'Дата последней перерегистрации', validate: isRequired },
  { name: 'bin', error: 'БИН / номер налогоплательщика', validate: isRequired },
  { name: 'registeringAuthorityName', error: 'Наименование регистрирующего органа', validate: isRequired },
  { name: 'residency', error: 'Резиденция', validate: isRequired },
  { name: 'economicSectorCode', error: 'Код сектора экономики', validate: isRequired },
  { name: 'authorizedCapital', error: 'Уставной капитал', validate: isRequired },
  { name: 'okeydAndActivities', error: 'ОКЭД и виды деятельности', validate: isRequired },
  { name: 'phoneAndFax', error: 'Телефон и факс', validate: isRequired },
  { name: 'legalCountry', error: 'Страна (юридический адрес)', validate: isRequired },
  { name: 'legalIndex', error: 'Индекс (юридический адрес)', validate: isRequired },
  { name: 'legalRegion', error: 'Область (юридический адрес)', validate: isRequired },
  { name: 'legalSettlement', error: 'Населенный пункт (юридический адрес)', validate: isRequired },
  { name: 'legalDistrict', error: 'Район (юридический адрес)', validate: isRequired },
  { name: 'legalStreet', error: 'Улица (юридический адрес)', validate: isRequired },
  { name: 'legalHouse', error: 'Дом (юридический адрес)', validate: isRequired },
  { name: 'legalOffice', error: 'Офис (юридический адрес)', validate: isRequired },
  { name: 'legalPhoneNumber', error: 'Сумма пенсии (юридический адрес)', validate: isRequired },
  { name: 'factCountry', error: 'Страна (фактический адрес)', validate: isRequired },
  { name: 'factIndex', error: 'Индекс (фактический адрес)', validate: isRequired },
  { name: 'factRegion', error: 'Область (фактический адрес)', validate: isRequired },
  { name: 'factSettlement', error: 'Населенный пункт (фактический адрес)', validate: isRequired },
  { name: 'factDistrict', error: 'Район (фактический адрес)', validate: isRequired },
  { name: 'factStreet', error: 'Улица (фактический адрес)', validate: isRequired },
  { name: 'factHouse', error: 'Дом (фактический адрес)', validate: isRequired },
  { name: 'factOffice', error: 'Офис (фактический адрес)', validate: isRequired },
  { name: 'factPhoneNumber', error: 'Сумма пенсии (фактический адрес)', validate: isRequired },
  { name: 'carPrice', error: 'Стоимость автомобиля', validate: isRequired },
  { name: 'downPaymentAmount', error: 'Сумма первоначального взноса', validate: isRequired },
  { name: 'downPayment', error: 'Первоначальный взнос', validate: isRequired },
  { name: 'loanTerm', error: 'Срок кредитования', validate: isRequired },
  { name: 'carBrand', error: 'Марка автомобиля', validate: isRequired },
  { name: 'requestedLoanAmount', error: 'Запрашиваемая сумма кредита', validate: isRequired },
  { name: 'loanCommission', error: 'Включать комиссию в сумму займа', validate: isRequired },
  { name: 'creditExperience', error: 'Опыт получения кредита', validate: isRequired },
  { name: 'creditDelinquencies', error: 'Просрочки по кредиту', validate: isRequired },
  { name: 'secondLevelBank', error: 'Банк второго уровня', validate: isRequired },
  { name: 'loanValidityPeriod', error: 'Срок действия (год)', validate: isRequired },
  { name: 'otherDetails', error: 'Другое', validate: isRequired },
  { name: 'fullName', error: 'ФИО', validate: isRequired },
  { name: 'citizenship', error: 'Гражданство', validate: isRequired },
  { name: 'iinOrBin', error: 'ИИН / БИН', validate: isRequired },
  { name: 'documentNumber', error: 'Номер документа', validate: isRequired }
]

export const loanApplicationDataFields = isCreditCL01 => {
  const baseFields = [
    { name: 'creditProduct', error: 'Кредитный продукт', validate: isRequired },
    { name: 'numberOfTranches', error: 'Количество траншей', validate: isRequired },
    { name: 'loanPurpose', error: 'Цель кредита', validate: isRequired }
  ]

  return isCreditCL01 ? [...baseFields, { name: 'loanAmount', error: 'Сумма займа', validate: isRequired }] : baseFields
}

export const collateralDataFields = type => {
  const baseFields = [
    { name: 'type', error: 'Тип залога', validate: isRequired },
    { name: 'collateralValue', error: 'Залоговая стоимость', validate: isRequired }
  ]

  const carDataFields = [
    { name: 'group', error: 'Группа', validate: isRequired },
    { name: 'dealership', error: 'Автосалон', validate: isRequired },
    { name: 'downPaymentPercentage', error: 'Первоначальный взнос', validate: isRequired },
    { name: 'downPaymentAmount', error: 'Первоначальный взнос (сумма)', validate: isRequired },
    { name: 'loanAmount', error: 'Сумма займа', validate: isRequired },
    { name: 'brand', error: 'Марка', validate: isRequired },
    { name: 'model', error: 'Модель', validate: isRequired },
    { name: 'yearOfManufacture', error: 'Год выпуска', validate: isRequired },
    { name: 'color', error: 'Цвет' }
  ]

  const realEstateDataFields = [
    { name: 'propertyType', error: 'Тип недвижимости', validate: isRequired },
    { name: 'totalArea', error: 'Общая площадь', validate: isRequired },
    { name: 'livingArea', error: 'Жилая площадь', validate: isRequired },
    { name: 'wallMaterial', error: 'Материал стен', validate: isRequired },
    { name: 'buildingYear', error: 'Год постройки', validate: isRequired },
    { name: 'registrationDateAndNumber', error: 'Дата и номер регистрации', validate: isDate },
    { name: 'cadastreNumber', error: 'Кадастровый номер', validate: isRequired },
    { name: 'rightAct', error: 'Акт на право частной', validate: isRequired }
  ]

  switch (type) {
    case 'CAR':
      return [...baseFields, ...carDataFields]
    case 'REAL_ESTATE':
      return [...baseFields, ...realEstateDataFields]
    case 'CLIENT':
      return [...baseFields, ...clientDataFields]
    case 'LEGAL_CLIENT':
      return [...baseFields, ...legalGuaranteeFields]
    default:
      return [{ name: 'type', error: 'Тип залога', validate: isRequired }]
  }
}

export const documentDescriptions = (
  <>
    <FormHelperText>Удостоверение личности клиента (УДВ)</FormHelperText>
    <FormHelperText>Анкета подписанная клиентом</FormHelperText>
    <FormHelperText>Согласие на сбор и обработку данных в форме Шинхан финанс</FormHelperText>
    <FormHelperText>Фото клиента</FormHelperText>
  </>
)
